import { SidebarItem } from '../screens';
import { useParams } from 'react-router-dom';
import { useBreadcrumbs, useUser } from '../hooks';
import UserAccess from '../UserAccess';

var WarehouseSidebar = ()=> {
	var { warehouseId } = useParams();
	var { showInventorySearch } = useBreadcrumbs();
	var { hasAccess } = useUser();

	return <>
		<SidebarItem text='Buscar' iconName='search' onClick={showInventorySearch} />
		<SidebarItem iconName='arrow-left' text='Regresar' to='/warehouses' />
		<div className='divider'>Almacén</div>
		{hasAccess(UserAccess.INVENTORY.VIEW_INVENTORY) && (
			<SidebarItem iconName='boxes' text='Inventario' to={`/warehouses/${warehouseId}`} />
		)}
	</>;
}

export default WarehouseSidebar;
